<template>
  <div>
    <div
      class="flex justify-between items-center self-stretch px-4 mb-1 pb-2 border-b-2 border-border"
    >
      <p
        class="text-text text-center font-serif text-lg font-normal leading-normal uppercase w-full whitespace-nowrap block truncate overflow-hidden"
      >
        {{ $t("channel.contests.quiz.leaderboard.title") }}
      </p>
    </div>

    <ContestLeaderboard :loading="loading" :ranking="ranking" class="flex-1" />
  </div>
</template>

<script lang="ts">
import { graphql as gql } from "@/generated";
import { useChannelStore } from "@/stores/channel.store";

import type { ResultOf } from "@graphql-typed-document-node/core";

export const QuizLeaderboardFragment = gql(/* GraphQL */ `
  fragment QuizLeaderboardData on Quiz {
    id
    quiz_questions {
      id
    }
  }
`);

export const GetQuizLeaderboardDocument = gql(/* GraphQL */ `
  query GetQuizLeaderboard($quiz_id: String!) {
    quizLeaderboard(quiz_id: $quiz_id) {
      ranking {
        ...ContestLeaderboardUser
      }
      participation_count
    }
  }
`);
</script>

<script setup lang="ts">
import { useQuery } from "@vue/apollo-composable";
import { computed } from "vue";
import ContestLeaderboard, {
  ContestLeaderboardUserFragment,
} from "../../contest/contest-leaderboard.vue";

type QuizForLeaderboard = ResultOf<typeof QuizLeaderboardFragment>;
type ContestLeaderboardUser = ResultOf<typeof ContestLeaderboardUserFragment>;

const props = defineProps<{
  quiz: QuizForLeaderboard;
  showClose?: boolean;
}>();

const _emit = defineEmits<{
  close: [];
  delete: [];
  share: [];
}>();

const _channelStore = useChannelStore();

const { result: leaderboard, loading } = useQuery(
  GetQuizLeaderboardDocument,
  computed(() => ({ quiz_id: props.quiz.id })),
);

const ranking = computed(() => {
  const value = leaderboard.value?.quizLeaderboard.ranking ?? [];

  return value.map((r) => r as ContestLeaderboardUser);
});

const _questionsCount = computed(() => {
  return props.quiz.quiz_questions?.length
    ? props.quiz.quiz_questions?.length
    : 0;
});
</script>
